import { render, staticRenderFns } from "./AppNavDrawer.vue?vue&type=template&id=31a8097e&scoped=true"
import script from "./AppNavDrawer.vue?vue&type=script&lang=js"
export * from "./AppNavDrawer.vue?vue&type=script&lang=js"
import style0 from "./AppNavDrawer.vue?vue&type=style&index=0&id=31a8097e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a8097e",
  null
  
)

export default component.exports